import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";

const DataRow = ({
  recruitment_name,
  datime,
  enterprise_name,
  remark,
  address,
  phone1,
  phone2,
  mianshishijian,
  employer,
  job,
}) => (
  <div className="card border-0 p-3 user-radius mb-2 mt-2">
    <div className="row">
      <div className="col">
        <div className="pull-left">
          <strong>{recruitment_name || job || ""}</strong>
        </div>
        <div className="pull-right">
          <span className="pull-right text-muted" style={{ fontSize: 11 }}>
            {datime}
          </span>
        </div>
        <br />
        <span className="text-success">{enterprise_name || employer || ""}</span>
        <br />
        {remark && (
          <>
            <span className="pull-left text-muted" style={{ fontSize: 11 }}>
              {remark}
            </span>
            <br />
          </>
        )}
        <span className="text-muted" style={{ fontSize: 11 }}>
          面试地点: {address}
        </span>
        <br />
        <span className="text-muted" style={{ fontSize: 11 }}>
          联系电话1: {phone1}
        </span>
        <br />
        {phone2 && (
          <>
            <span className="text-muted" style={{ fontSize: 11 }}>
              联系电话2: {phone2}
            </span>
            <br />
          </>
        )}
        <span className="text-muted" style={{ fontSize: 11 }}>
          面试时间: {moment(mianshishijian).format("YYYY-MM-DD H:mm")}
        </span>
      </div>
    </div>
  </div>
);

DataRow.propTypes = {
  recruitment_name: PropTypes.string,
  datime: PropTypes.string.isRequired,
  enterprise_name: PropTypes.string,
  remark: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  phone1: PropTypes.string.isRequired,
  phone2: PropTypes.string,
  mianshishijian: PropTypes.string.isRequired,
};

DataRow.defaultProps = {
  recruitment_name: undefined,
  enterprise_name: undefined,
  phone2: undefined,
};

const Offer = () => {
  const [list, setList] = useState([]);

  // const [totalFlg, setTotalFlg] = useState(false);

  const [auth, setAuth] = useState(0);

  useEffect(() => {
    let jobId = -1;
    const _auth = JSON.parse(localStorage.getItem("auth"));

    if (_auth !== null) {
      setAuth(_auth);
      // fetch(`/api/offer/common/${_auth.id}`)
      //   .then((res) => res.json())
      //   .then((res) => {
      //     setList(res.content);
      //     // setTotalFlg(true);
      //   });
      fetch(`/gin-api/interview?option=by-ref&refID=${_auth.id}`)
        .then((response) => response.json())
        .then((data) => {
          setList(data);
        });

      jobId = setInterval(() => {
        fetch(`/api/offer/common/${_auth.id}`)
          .then((res) => res.json())
          .then((res) => {
            setList(res.content);
          });
      }, 900000);
      return () => {
        if (jobId !== -1) {
          clearInterval(jobId);
        }
      };
    }
  }, []);

  const handleLogIn = async () => {
    location.href = "#/登录?id=1";
  };

  return (
    <>
      {auth === 0 ? (
        <div className="container-fluid">
          <div className="chat-login">
            <h6>登录后可以查看邀请</h6>
            <button
              type="button"
              style={{ width: "25%" }}
              className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
              onClick={handleLogIn}
            >
              登&nbsp;录
            </button>
          </div>
        </div>
      ) : (
        <div className="container-fluid" style={{ fontSize: 14 }}>
          {list.length === 0 ? (
            <div className="chat-login">
              <h6>您还没有新的面试邀请</h6>
            </div>
          ) : (
            <div>
              {list?.map((item) => (
                <DataRow
                  key={item.id}
                  {...item}
                  employer={item?.job?.employer?.name || ""}
                  job={item?.job?.name || ""}
                />
              ))}
            </div>
          )}
        </div>
      )}
      <Navbar category="我的" />
      {/* <Navbar category="我的" totalFlg={totalFlg} /> */}
    </>
  );
};

export default Offer;
